// extracted by css-extract-rspack-plugin
var _1 = "table-nczRxH";
export { _1 as "table" }
